import React from 'react'
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

import baseClasses from './BaseModal.module.scss'
import clsx from 'clsx';


const BaseModal = ({open, onClose, classes, children}) => {

  return <Modal open={open} onClose={onClose}>
    <div className={clsx(baseClasses.root, classes && classes.root)}>
      <div className={baseClasses.head}><CloseIcon onClick={onClose} /></div>
      {children}
    </div>
  </Modal>
}

export default BaseModal;